import React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const BankIFSCCodeListApi = createSlice({
  name: "BankIFSCCodeListApi",
  initialState: {
    isLoading: false,
    isSuccess: false,
    data: [],
  },
  reducers: {
    list_bank_Ifsc_code: (state, action?: any) => {
      state.isLoading = true;
    },
    success_api_call_bank_Ifsc_code: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
    },
    failure_api_call_bank_Ifsc_code: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
    },
    clear_data_bank_Ifsc_code: (state) => {
      state.data = [];
    },
  },
});
export default BankIFSCCodeListApi.reducer;
export const {
  list_bank_Ifsc_code,
  success_api_call_bank_Ifsc_code,
  failure_api_call_bank_Ifsc_code,
  clear_data_bank_Ifsc_code,
} = BankIFSCCodeListApi.actions;
